import { render, staticRenderFns } from "./CheckboxFilter.vue?vue&type=template&id=41d88b40&scoped=true&"
import script from "./CheckboxFilter.vue?vue&type=script&lang=js&"
export * from "./CheckboxFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d88b40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
